import {
  searchCriteria,
  // factoryCoo,
  factory,
  // qasBrand,
  qasVendor,
  qasQARegion,
  qasCountryPQA,
  qasAuditStage,
  qasAuditStatus,
  qasAuditorName,
  qasLastUser,
  qasHasMapping,
  qasDefects,
  qasAuditPoint,
  qasUserAuditPoint,
  qasFolder
} from './definition'

const sortByName = (list) => {
  return list.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    } else if (a.name > b.name) {
      return 1
    } else {
      return 0
    }
  })
}

const sortByCustomName = (list, name) => {
  return list.sort((a, b) => {
    if (a[name] < b[name]) {
      return -1
    } else if (a[name] > b[name]) {
      return 1
    } else {
      return 0
    }
  })
}

export default {
  // [factoryCoo] (state, value) {
  //   state.factoryCoo = sortByName(value)
  // },
  [factory] (state, value) {
    state.factory = sortByCustomName(value, 'l_factory_nm')
  },
  // [qasBrand] (state, value) {
  //   state.qasBrand = sortByName(value)
  // },
  [qasVendor] (state, value) {
    state.qasVendor = sortByName(value)
  },
  [qasQARegion] (state, value) {
    state.qasQARegion = sortByCustomName(value, 'pqa_region')
  },
  [qasCountryPQA] (state, value) {
    state.qasCountryPQA = sortByCustomName(value, 'country_pqa')
  },
  [qasAuditStage] (state, value) {
    state.qasAuditStage = sortByName(value)
  },
  [qasAuditStatus] (state, value) {
    state.qasAuditStatus = sortByCustomName(value, 'audit_stauts_name')
  },
  [qasAuditorName] (state, value) {
    state.qasAuditorName = sortByCustomName(value, 'auditor_name')
  },
  [searchCriteria] (state, { field, value }) {
    state.searchCriteria[field] = value
  },
  [qasLastUser] (state, value) {
    state.qasLastUser = value
  },
  [qasHasMapping] (state, value) {
    state.qasHasMapping = value
  },
  [qasDefects] (state, value) {
    state.qasDefects = value
  },
  [qasAuditPoint] (state, value) {
    state.qasAuditPoint = value
  },
  [qasUserAuditPoint] (state, value) {
    state.qasUserAuditPoint = value
  },
  [qasFolder] (state, value) {
    state.qasFolder = value
  }
}



// WEBPACK FOOTER //
// ./src/components/qas/common/store/mutations.js